import { render, staticRenderFns } from "./ModalConfirmarRemocaoEvidencia.vue?vue&type=template&id=2c5722c6&lang=pug"
import script from "./ModalConfirmarRemocaoEvidencia.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarRemocaoEvidencia.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarRemocaoEvidencia.vue?vue&type=style&index=0&id=2c5722c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports